import { RequestBuilder } from "../request-builder";

export interface ClusterMember {
  id: string;
  type: "contact" | "company" | "unknown";
  name: string;
}

export interface CrmCluster {
  cluster_id: string;
  label: string;
  summary: string;
  members: ClusterMember[];
  modularity: number;
  size: number;
}

export function createCrmClustersNamespace(rb: RequestBuilder) {
  return {
    /**
     * Discovers relationship clusters in the workspace CRM using community detection.
     * Each cluster is automatically labeled by AI.
     *
     * @param workspaceId - The workspace ID to discover clusters for
     * @returns Array of discovered clusters with AI-generated labels
     * @example
     * ```typescript
     * const { data } = await admin.crmClusters.discover('workspace-uuid');
     * ```
     */
    async discover(workspaceId: string): Promise<CrmCluster[]> {
      return rb.rawGet<CrmCluster[]>(
        `/isv/crm/clusters?workspace_id=${encodeURIComponent(workspaceId)}`,
      );
    },
  };
}
